import React from "react";
import { Box, Container, makeStyles, Modal, IconButton } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import customModalStyle from "./customModalStyle";

const useStyles = makeStyles((theme) => customModalStyle(theme));

const CustomModal = ({children, open = false, onClose}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box className={classes.overlay}>
        <Container>
          <IconButton
            className={classes.closeButton}
            aria-label="close"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
          {children}
        </Container>
      </Box>
    </Modal>
  )
}

export default CustomModal
